import makeActionCreator from 'utils/makeActionCreator';

import {
  SET_FILES_FROM_DRAFT_ACTION,
  SET_FILES_SENDED_ACTION,
} from './constants';

export const setFilesFromDraftAction = makeActionCreator(SET_FILES_FROM_DRAFT_ACTION, 'files');
export const setFilesSendedAction = makeActionCreator(SET_FILES_SENDED_ACTION, 'files');
